import React, { Component } from 'react';

import { withTranslation } from 'react-i18next';

import HeaderComponent from '../../commons/header/headerComponent';
import DatePicker, { registerLocale } from 'react-datepicker';
import { getCookie } from '../../../utils/cookies';
import api from '../../../utils/api';
import apiResponseMessage from '../../../utils/apiResponse';
import FooterComponent from '../../commons/footer/footerComponent';
import PreloaderComponent from '../../commons/preloader/preloaderComponent';
import './purchaseComponent.css';
import Collapsible from 'react-collapsible';
import fi from 'date-fns/locale/fi';

registerLocale('fi', fi);

class PurchasesComponent extends Component {
    constructor(props) {
        super(props);

        const now = new Date();

        this.state = {
            isLoading: false,
            success: null,
            message: null,
            data: null,
            startDate: new Date(now.setFullYear(now.getFullYear() - 1)),
            endDate: new Date(),
        };
    }

    async fetchData() {
        this.setState({
            isLoading: true,
        });
        try {
            let body = {
                startDate: this.state.startDate,
                endDate: this.state.endDate,
            };
            let response = await api.post('/purchase/summary', body, {
                headers: {
                    Authorization: getCookie('jasenrekisteri-token'),
                    'Content-Type': 'application/json',
                },
            });

            this.setState({
                ...this.state,
                isLoading: false,
                success: true,
                data: response.data,
            });
        } catch (e) {
            this.setState({
                ...this.state,
                ...{
                    success: false,
                    message:
                        apiResponseMessage(e?.response?.data, 'adminPurchases.requestFailed'),
                    isLoading: false,
                },
            });
        }
    }

    render() {
        const { isLoading, data, startDate, endDate } = this.state;
        const { t, i18n } = this.props;
        // 'en' is react-datepicker's built-in default; everything else falls
        // back to Finnish alongside the app locales.
        const datePickerLocale = i18n.language?.startsWith('en')
            ? 'en'
            : 'fi';

        return (
            <div>
                <HeaderComponent />
                <div className="info-container">
                    <h3>{t('adminPurchases.title')}</h3>
                    <p>{t('adminPurchases.introFetch')}</p>
                    <p>{t('adminPurchases.introNote')}</p>
                </div>
                <div className="actions">
                    <DatePicker
                        selected={startDate}
                        onChange={(value) =>
                            this.setState({
                                startDate: value,
                            })
                        }
                        dateFormat="dd.MM.yyyy"
                        className="form-control"
                        locale={datePickerLocale}
                    />
                    <h1>-</h1>
                    <DatePicker
                        selected={endDate}
                        onChange={(value) =>
                            this.setState({
                                endDate: value,
                            })
                        }
                        dateFormat="dd.MM.yyyy"
                        className="form-control"
                        locale={datePickerLocale}
                    />
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => this.fetchData()}
                    >
                        {t('adminPurchases.fetch')}
                    </button>
                </div>{' '}
                {isLoading && <PreloaderComponent />}
                {data &&
                    Object.keys(data).map((date) => {
                        const dateData = data[date];

                        const totalPrice = Object.keys(dateData)
                            .map((storeItem) => {
                                const storeItemData = dateData[storeItem];
                                return Object.keys(storeItemData)
                                    .map((p) => storeItemData[p].totalPrice)
                                    .reduce((a, b) => a + b, 0);
                            })
                            .reduce((a, b) => a + b, 0);

                        return (
                            <Collapsible
                                key={date}
                                trigger={
                                    <div className="collapsible-trigger-container">
                                        <h5>
                                            {date} <b>- {totalPrice} €</b>
                                        </h5>
                                        <h2>+</h2>
                                    </div>
                                }
                                classParentString="collapsible date-level"
                                transitionTime={100}
                            >
                                {Object.keys(data[date]).map((storeItem) => {
                                    const storeItemData = data[date][storeItem];

                                    const totalItems = Object.keys(
                                        storeItemData
                                    )
                                        .map((p) => storeItemData[p].amount)
                                        .reduce((a, b) => a + b, 0);
                                    const totalPrice = Object.keys(
                                        storeItemData
                                    )
                                        .map((p) => storeItemData[p].totalPrice)
                                        .reduce((a, b) => a + b, 0);
                                    return (
                                        <Collapsible
                                            key={storeItem}
                                            trigger={
                                                <div className="collapsible-trigger-container">
                                                    <h6>
                                                        <b>{totalItems} x</b>{' '}
                                                        {storeItem}{' '}
                                                        <b>- {totalPrice} €</b>
                                                    </h6>
                                                    <h2>+</h2>
                                                </div>
                                            }
                                            classParentString="collapsible store-item-level"
                                            transitionTime={100}
                                        >
                                            {Object.keys(
                                                data[date][storeItem]
                                            ).map((product) => {
                                                const prodData =
                                                    data[date][storeItem][
                                                        product
                                                    ];
                                                return (
                                                    <p key={product}>
                                                        <b>
                                                            {prodData.amount} x
                                                        </b>{' '}
                                                        {product}{' '}
                                                        <b>
                                                            -{' '}
                                                            {
                                                                prodData.totalPrice
                                                            }{' '}
                                                            €
                                                        </b>
                                                    </p>
                                                );
                                            })}
                                        </Collapsible>
                                    );
                                })}
                            </Collapsible>
                        );
                    })}
                <FooterComponent />
            </div>
        );
    }
}

export default withTranslation()(PurchasesComponent);
